<template>
    <section>
      <v-btn @click="dialog = true" class="success"><v-icon class="mr-2">mdi-cog-transfer</v-icon>{{$t('globals.transfer')}}</v-btn>
        <div style="position:relative">
          <v-container>
            <v-speed-dial
              absolute
              v-model="speedDial"
              top
              right
              direction="bottom"
              :open-on-hover="true"
            >
              <template v-slot:activator>
                <v-tooltip right color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      v-model="speedDial"
                      color="primary"
                      dark
                      x-large
                      fab
                    >
                      <v-icon v-if="speedDial">
                        mdi-close
                      </v-icon>
                      <v-icon v-else>
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('globals.options')}}</span>
                </v-tooltip>
              </template>              
              <v-tooltip right color="info" v-if="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    fab
                    dark
                    small
                    color="info"
                    large
                    @click="searching = true"
                  >
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('globals.search')}}</span>
              </v-tooltip>              
            </v-speed-dial>
          </v-container>
  
          <v-data-table 
            :style="this.$root.$vuetify.theme.isDark ? '' : 'background-color: rgba(255, 255, 255, 0.75) !important;'"
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            :footer-props="tableFooter"
            :options.sync="options"
            :class="this.$root.$vuetify.theme.isDark ? 'secondary mt-16' : 'mt-16'"
            locale="pt-pt"
          >
            <template v-slot:item.qty="{item}">
                {{ item.qty }} {{item.unidade.abbreviation}} 
            </template>

            <template v-slot:item.actions="{item}">
              <v-row>
                <v-col cols="12" md="auto">
                  <v-btn text fab outlined small @click="removeMaterial(item)">
                    <v-icon>mdi-swap-horizontal</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="auto">
                  <v-btn text fab outlined small @click="openHistory(item)">
                    <v-icon>mdi-history</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
                                
          </v-data-table>
        </div>
        <v-navigation-drawer
            fixed
            right
            v-model="searching"
            hide-overlay
            width="520"
            class="pt-6"
          >
          <v-list>
            <v-list-item>
              <v-btn fab small color="secondary" @click="searching = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
  
              <v-btn absolute right small color="error" @click="resetLocation">
                {{$t('globals.clean_fields')}}
              </v-btn>
            </v-list-item>
          </v-list>
          <v-list class="pt-10">
            <v-form @submit.prevent="searchMaterialsLocation">
              
              
  
              <v-row
                class="mt-10"
                align="center"
                justify="space-around"
              >
              <v-btn
                color="primary"
                type="submit"
              >
              {{$t('globals.search')}}
              </v-btn>
              </v-row>
            </v-form>
          </v-list>
        </v-navigation-drawer>
  
        
        <ErrorSnackbar v-model="error.show" :message="error.message"/>

        <v-dialog
          v-model="dialog"
          width="900px"
        >
          <v-toolbar class="primary white--text">{{$t('globals.material')}}</v-toolbar>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <span class="mt-8">{{$t('materials.transfer')}}</span>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="materialWork.work_id"
                    :label="$t('globals.work')"
                    :items="works"
                    item-value="id"
                    :item-text="item => item.code + ' - ' + item.name"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="materialWork.qty"
                    :label="$t('globals.quantity')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row align="center" class="mb-6" justify="space-around">
                <v-btn @click="transferMaterial" :disabled="materialWork.work == null && materialWork.qty == null" depressed :class="$root.$vuetify.theme.isDark ? 'white primary--text' : 'primary white--text'">             
                  {{$t('globals.save')}}
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
      </v-dialog>



      <v-dialog
          v-model="dialogRemove"
          width="900px"
        >
          <v-toolbar class="primary white--text">{{$t('globals.material')}}</v-toolbar>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <span class="mt-8">{{$t('materials.remove')}}</span>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    readonly
                    v-model="materialWork.work_id"
                    :label="$t('globals.work')"
                    :items="works"
                    item-value="id"
                    :item-text="item => item.code + ' - ' + item.name"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="materialWork.qty"
                    :label="$t('globals.quantity')"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="materialWork.other_work"
                    :label="$t('materials.transfer_other_work')"
                  />
                </v-col>
                <v-col cols="12" md="6" v-if="materialWork.other_work">
                  <v-autocomplete
                    v-model="materialWork.work_id_destination"
                    :label="$t('globals.work')"
                    :items="works"
                    item-value="id"
                    :item-text="item => item.code + ' - ' + item.name"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row align="center" class="mb-6" justify="space-around">
                <v-btn @click="removeMaterialAction" :disabled="materialWork.work == null && materialWork.qty == null" depressed :class="$root.$vuetify.theme.isDark ? 'white primary--text' : 'primary white--text'">             
                  {{$t('globals.save')}}
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
      </v-dialog>


      <v-dialog v-model="history.open"
          width="900px">
        <v-toolbar class="primary white--text">{{$t('globals.history')}}</v-toolbar>
        <v-card class="elevation-0">
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
              <thead>
                  <tr>
                  <th>
                      {{$t('globals.user')}}
                  </th>
                  <th class="text-left">
                      {{$t('globals.quantity')}}
                  </th>
                  <th class="text-left">
                      {{$t('globals.data')}}
                  </th>
                  <th class="text-left">
                      {{$t('globals.from')}}
                  </th>
                  <th class="text-left">
                      {{$t('globals.to_para')}}
                  </th>
                  </tr>
              </thead>
              <tbody v-for="item in history.item.story" :key="item.id">
                  <tr>
                      <td>{{ item.who }}</td>
                      <td>{{ item.action }}</td>
                      <td>{{ item.created_at }}</td>
                      <td>{{ item.from_work }}</td>
                      <td>{{ item.to_work }}</td>
                  </tr>
              </tbody>
            </template>
          </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <SuccessSnackBar v-model="modalSuccess.show" :message="modalSuccess.message"/>

    </section>
  </template>
  <script>
  import Materials from "@/api/Materials.js";
  import Work from '@/api/Work.js'
  import ErrorSnackbar from '@/components/ui/ErrorSnackbar.vue';
  import SuccessSnackBar from '@/components/ui/SuccessSnackBar.vue';
  
  export default {
    components: {
      ErrorSnackbar,
      SuccessSnackBar
    },
    props:{
      material: Object
    },
    watch: {
      'options': {
        immediate: false,
        handler () {
          setTimeout(() => {this.searchMaterialsLocation()}, 10);
        },
        deep: true,
      },
    },
    data: () => ({
      dialog: false,
      dialogRemove: false,
      materialWork:{
        work_id: null,
        qty: null,
        material_id: null,
        aux: null,
        other_work: false,
        work_id_destination: null
      },
      error: {
        title: '',
        message: '',
        show:false,
      },
      items: [],
      works: [],
      total: 0,
      loading: false,
      searching: false,
      options: {},
      speedDial:false,
      filter: {
        material_id: null
      },
      success: false,
      modalSuccess:{
        show: false,
        msg: ''
      },
      history:{
        item: null,
        open: false
      }
    }),
    mounted(){
      this.modalSuccess.msg = this.$t('materials.success');

      if(!this.$root.session.hasPermission(["super", "materials.read"])) {
        this.$router.push('/admin');
      }
  
  
      this.fillBaseData();
    },
    methods:{
      openHistory(item){
        this.history.item = null
        this.history.open = false
        this.history.item = item
        this.history.open = true
      },
      removeMaterialAction(){
        if(this.materialWork.qty > this.materialWork.aux){
          this.error.message = this.$t('materials.error_transfer_2')
          this.materialWork.qty = this.materialWork.aux;
          this.error.show = true
          return
        }

        Materials.removeFromWarehouse(this.materialWork).then(() => {
    
          this.modalSuccess.show = true;

          this.loading = false;

          this.dialogRemove = false

          this.searchMaterialsLocation()

          this.$emit('update-material')

        }).catch(err => {
            this.loading = false;

            if(err.response.status == 422) {

                this.$refs.form.setErrors(err.response.data.errors);
                
                return;
            }

            this.error.title = this.$t('globals.error') + " " + err.response.status;

            this.error.message = err.response.data.message;

          });

      },
      removeMaterial(item){
        this.materialWork = item
        this.materialWork.aux = item.qty
        this.dialogRemove = true
      },
      transferMaterial(){
        this.materialWork.material_id = this.$route.params.id

        this.loading = true

        if(this.material.stock < this.materialWork.qty){
          this.error.message = this.$t('materials.error_transfer')
          this.error.show = true
          this.loading = false
          return
        }
        

        Materials.changeWarehouse(this.materialWork).then(() => {
    
            this.modalSuccess.show = true;

            this.loading = false;

            this.dialog = false

            this.searchMaterialsLocation()

            this.$emit('update-material')
            
        }).catch(err => {
            this.loading = false;

            if(err.response.status == 422) {

                this.$refs.form.setErrors(err.response.data.errors);
                
                return;
            }

            this.error.title = this.$t('globals.error') + " " + err.response.status;

            this.error.message = err.response.data.message;

          });
      },
      fillBaseData() {
  
        if(localStorage["materials-locations-" + this.$root.session.id] != undefined){
  
          let data = JSON.parse(localStorage["materials-locations-" + this.$root.session.id]);
  
          this.filter = data.filter;
  
          this.options = data.options;
        }

        Work.list().then(({data}) => {
            this.works = data
        });
      },
      searchMaterialsLocation(event){
        if(!!event && event.type == 'submit'){
          this.options.page = 1;
        }
  
        this.loading = true;

        this.filter.material_id = this.$route.params.id
  
        let filter = {...this.filter};
        
        let request = {
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          page: this.options.page,
          limit: this.options.itemsPerPage,
          filter: filter
        };
      
        Object.assign(request, filter);
  
        localStorage["materials-locations-" + this.$root.session.id] = JSON.stringify({
          filter: this.filter,
          options: this.options,
        });
  
        Materials.searchLocal(request).then(response => {
  
          let data = response.data;
  
          this.total = data.total;
  
          this.items = data.data.map((item) => {
  
            this.searching = false;
  
            return item;
          });
  
          this.loading = false;
  
        });
      },
      resetLocation()
      {
        this.filter = {
          is_active: 1
        };
  
        this.searchMaterialsLocation();
      },
    },
    computed: {
      headers(){
        let he = [          
          {
            text: this.$t('globals.work'),
            sortable: true,
            value: 'work.name'
          },          
          {
            text: this.$t('globals.quantity'),
            sortable: true,
            value: 'qty'
          },           
          {
            text: this.$t('globals.created_at'),
            sortable: true,
            value: 'created_at'
          },           
          {
            text: this.$t('globals.updated_at'),
            sortable: true,
            value: 'updated_at'
          },          
          {
            text: this.$t('globals.options'),
            sortable: false,
            value: 'actions'
          },        
        ]
        return he
      },
      tableFooter(){
        let t = this.$t("globals.lines_datatable")
        let a = [5, 10, 15, 20];
        return {
          'items-per-page-options': a,
          'items-per-page-text': t
        }
      }, 
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.material_management'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  